import { ProfileData, v2 } from '@deqo/api-bindings';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { telemetry } from '../telemetry/Telemetry';

export const useProfileQuery = () =>
    useQuery({
        queryKey: ['me.info'],
        queryFn: async (): Promise<ProfileData> => {
            const call = v2.me.info();
            const res = await fetch(`/api/v2${call.path}`, { headers: { accept: 'application/json' } });
            if (!res.ok) throw new Error(`Status ${res.status}`);
            const data = await res.json();
            return call.transform ? call.transform(data) ?? data : data;
        },
    });

// Identify the authenticated user with telemetry. Uses ProfileData.id (the same id
// web-app identifies on) so the anon -> user alias chains line up across both apps.
export const useIdentify = () => {
    const { data: profile } = useProfileQuery();
    useEffect(() => {
        if (profile) {
            telemetry.identify({
                id: profile.id,
                name: profile.name,
                email: profile.email,
                createdAt: profile.createdAt,
            });
        }
    }, [profile?.id]);
};
